/**
 * MonthlyReportPage — deep-link wrapper for /dashboard/.../:monthKey.
 * Renders the unified Reports page preselected on the linked month.
 */

import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { trackFeature, FEATURE_KEYS } from "../../services/telemetry";
import MonthlyReportsPage from "./MonthlyReportsPage";

const MonthlyReportPage = () => {
  const { monthKey } = useParams();

  useEffect(() => {
    trackFeature(FEATURE_KEYS.MONTHLY_REPORTS);
  }, []);

  return <MonthlyReportsPage monthKey={monthKey} />;
};

export default MonthlyReportPage;
